import { styled } from '@mui/system'
import { colors, fontSizes } from '../../../Components/consts'

type WeekProps = {
  active: boolean
}

export const WeekItemStyle = styled('button')<WeekProps>(({ active, theme }) => ({
  position: 'relative',
    textAlign: 'center',
    padding: theme.spacing(1.5, 4),
    margin: theme.spacing(2, 1),
    fontSize: fontSizes.small,
    fontWeight: 700,
    color: active ? colors.black : colors.gray.gray40,
    border: active ? `1px solid ${colors.yellow}` : `1px solid ${colors.white}`,
    borderRadius: 15,
    background: active ? colors.yellow : 'transparent',
    cursor: 'pointer',
    '&:hover': {
      color: active ? colors.black : colors.gray.gray40,
      backgroundColor: active ? colors.yellow : 'transparent',
      border: active ? 'none' : `1px solid ${colors.text}`,
    },
    '&:focus': {
      outline: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8rem',
      margin: theme.spacing(0.5, 0.25),
      padding: theme.spacing(1, 2),
    },
}))